<template>
  <option-general value="times_until_action" :label="$t('edit.sidebar.times_until_action')">
    <div class="box-input-group">
      <input
        class="box-input"
        type="number"
        :value="boxConfig.advanced.exibition_frequency_times_value"
        @change="boxUpdateConfig({ item: 'advanced', key: 'exibition_frequency_times_value', value: $event.target.value });">
      <span class="box-input-group-label">{{ $t('general.labels.times') }}</span>
    </div>
  </option-general>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import OptionGeneral from './general/Main.vue';

export default {
  components: {
    OptionGeneral,
  },
  methods: mapActions([
    'boxUpdateConfig',
  ]),
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>
exibition_mode_time_value



/** WEBPACK FOOTER **
 ** TimesUntilAction.vue?4cc4ca0a
 **/